import React, { useContext, useEffect, useReducer, useState } from 'react';

import { Route, useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';

import type { IStoreRedux } from 'Types/Reducers';

import { Container, Content, Toolbar } from '../../../../componentes/Interface';

import { formataEtapas } from '../config';
import { reducerEtapas } from './reducer';

import InscricaoContext from '../../context';
import Final from '../Final';
import InscricaoHashLink from '../InscricaoHashLink';
import InscricaoHashEvento from '../InscricaoHashEvento';
import InscricaoHashConvite from '../InscricaoHashConvite';
import InscricaoPadrao from '../InscricaoPadrao';
import Inicial from '../Inicial';

import ArcoIcon from '../../../../_recursos/imagens/arco-icon.svg';
import LibcomIcon from '../../../../_recursos/imagens/libcom-icon.svg';
import InscricaoComCpf from '../InscricaoComCpf';
import { salvarEscolhaVoluntariado, tentarPorCpf } from './metodos-etapas';
import Toast from '../../../../componentes/Toast';

function getEtapaInscricao(inscricao: { tipohash: string; temVoluntariado?: boolean }) {
  switch (inscricao.tipohash) {
    case 'hashlink': return <InscricaoHashLink useRedis={!inscricao.temVoluntariado} />;
    case 'hashevento': return <InscricaoHashEvento />;
    case 'hashconvite': return <InscricaoHashConvite />;
    default:
      return <InscricaoPadrao />;
  }
}

function EstruturaEtapas() {
  const inscrito = useSelector((state: IStoreRedux) => state.app.inscrito);
  const posInscrito = useSelector((state: IStoreRedux) => state.app.posInscrito);
  const { carregando: appCarregando, referencia, idUsuario } = useSelector((state: IStoreRedux) => state.app);
  const voluntario = useSelector((state: IStoreRedux) => state.voluntario);
  const etapaAtual = useSelector((state: IStoreRedux) => state.app.etapaAtual!);
  const etapaValida = useSelector((state: IStoreRedux) => state.app.etapaValida);
  const dispatch = useDispatch();

  const history = useHistory();

  const { etapas, inscricao } = useContext(InscricaoContext);

  const [toast, dispatchToast] = useReducer(
    (state: any, { type, ...action }: { type: string, [x: string]: any }) => (type === 'set' ? { ...action } : { ...state, ...action }),
    {}
  );
  const [tentarInscricaoComCpf, setTentarInscricaoComCpf] = useState(false);

  const [controle, dispatchEtapas] = useReducer(
    reducerEtapas,
    { posicao: -1 },
    (arg) => {
      const etapasCustomizadas = formataEtapas(etapas);
      return { ...arg, etapas: etapasCustomizadas.inscricao, continuacao: etapasCustomizadas.posInscricao }
    },
  );

  const temVoluntariado = 'voluntariados' in etapas && etapas.voluntariados && etapas.voluntariados.length;
  const temSolicitacoes = controle.solicitacoes && controle.solicitacoes.length > 0;
  const temContinuacoes = controle.continuacao && controle.continuacao.length > 0;

  useEffect(() => {
    if (inscrito && temContinuacoes) {
      dispatchEtapas((atual: any) => ({ ...atual, posicao: atual.etapas.length }))
      history.push(controle.continuacao[0].path);
    }
  }, [controle.continuacao, history, inscrito, temContinuacoes])

  function navegaParaEtapaAnterior() {
    dispatchEtapas({ type: 'VOLTAR' });
    history.goBack()
  }

  async function navegaParaEtapaSeguinte() {
    const proxEtapa = controle.posicao + 1;

    if (inscrito && temContinuacoes) {
      // pos-inscricao
      if (etapaAtual === 'escolha-voluntariado') {
        dispatch({ type: 'ALTERA_CARREGANDO', carregando: true });
        const sucesso = await salvarEscolhaVoluntariado(
          { urlVoluntariado: voluntario.urlVoluntariado, referencia },
          { voluntariados: voluntario.perfisVoluntariado, idUsuario }
        )
          .finally(() => dispatch({ type: 'ALTERA_CARREGANDO', carregando: false }))

        if (sucesso) dispatch({ type: `ALTERA_INSCRITO_VOLUNTARIADO`, inscritoVoluntariado: true })
        else return dispatchToast({
          type: 'set',
          open: true,
          message: 'Não foi possível continuar! Tente novamente em poucos segundos...',
          duration: 5000,
          color: '#FF1F00'
        });
      }

      const qntdEtapas = controle.etapas.length + controle.continuacao.length
      if (controle.etapas.length <= proxEtapa && proxEtapa < qntdEtapas)
        return history.push(controle.continuacao[proxEtapa - controle.etapas.length].path)

      return dispatch({ type: 'ALTERA_POS_INSCRITO', posInscrito: proxEtapa >= qntdEtapas });
    }

    // durante inscrição
    if (tentarPorCpf(controle, etapas.cpf, etapaAtual)) return setTentarInscricaoComCpf(true);

    dispatchEtapas({ type: 'AVANCAR' });

    if (temSolicitacoes && (0 <= proxEtapa && proxEtapa < controle.solicitacoes.length))
      return history.push(controle.solicitacoes[proxEtapa].path);

    if (0 <= proxEtapa && proxEtapa < controle.etapas.length)
      return history.push(controle.etapas[proxEtapa].path);
  }

  const instituicao = /arco|libcom/.test(inscricao.schema);

  const icone = (
    instituicao
      ? (inscricao.schema === 'arco' ? ArcoIcon : LibcomIcon)
      : undefined
  );

  if (tentarInscricaoComCpf) {
    return (
      <InscricaoComCpf
        useRedis={!temVoluntariado}
        inscricao={inscricao}
        dispatchEtapas={dispatchEtapas}
        setTentarInscricaoComCpf={setTentarInscricaoComCpf}
        continuarComNovoCadastro={() => {
          dispatchEtapas({ type: 'AVANCAR' });
          history.push(controle.etapas[controle.posicao + 1].path);
        }}
      />
    );
  }

  if (controle.posicao < 0) {
    return <Inicial avancar={navegaParaEtapaSeguinte} icone={icone} />
  }

  if (!inscrito && controle.posicao >= controle.etapas.length)
    return getEtapaInscricao({ tipohash: inscricao.tipoHash, temVoluntariado });

  if (temContinuacoes ? posInscrito : inscrito) return <Final icone={icone} />;

  return (
    <Container>
      {/* Toolbar */}
      <Content>
        <Toolbar>
          {controle.posicao > 0 &&
            <IconButton onClick={navegaParaEtapaAnterior}>
              <ArrowBack />
            </IconButton>
          }
          {appCarregando && <CircularProgress color='primary' size={24}/>}
        </Toolbar>
      </Content>
      <Content full padding pb="3rem">
        {/* Campo do Input */}
        {
          temSolicitacoes &&
            controle.solicitacoes.map((solicitacao: any) => <Route {...solicitacao} key={solicitacao.path} />)
        }
        {
          (!temSolicitacoes && controle.posicao < controle.etapas.length) &&
            controle.etapas.map((etapa: any) => <Route {...etapa} key={etapa.path} />)
        }
        {
          (temContinuacoes && controle.posicao < controle.etapas.length + controle.continuacao.length) &&
            controle.continuacao.map((continuacao: any) => <Route {...continuacao} key={continuacao.path} />)
        }
        <br/><br/>

        <Button
          disabled={etapaValida !== true}
          size='large'
          variant='contained'
          color='primary'
          onClick={navegaParaEtapaSeguinte}
        >
          {appCarregando ? <CircularProgress /> : 'Continuar'}
        </Button>
      </Content>

      <Toast
        exibe={toast.open}
        setExibe={(open) => dispatchToast({ type: 'merge', open })}
        mensagem={toast.message}
        cor={toast.color}
        duration={toast.duration}
      />
    </Container>
  )
}

export default EstruturaEtapas;
